function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 67.83,
  x2: 474.19,
  y1: 82.42,
  y2: 389.98,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1e1b1e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#474747"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M256 0c141.39,0 256,114.61 256,256 0,141.39 -114.61,256 -256,256 -141.39,0 -256,-114.61 -256,-256 0,-141.39 114.61,-256 256,-256z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M180.8 159.38c53.36,0 96.62,43.26 96.62,96.62 0,53.36 -43.26,96.62 -96.62,96.62 -53.35,0 -96.61,-43.26 -96.61,-96.62 0,-53.36 43.26,-96.62 96.61,-96.62zm229.98 15.26c9.41,0 17.03,36.43 17.03,81.36 0,44.93 -7.62,81.36 -17.03,81.36 -9.4,0 -17.03,-36.43 -17.03,-81.36 0,-44.93 7.63,-81.36 17.03,-81.36zm-75.38 -7.63c27,0 48.88,39.84 48.88,88.99 0,49.15 -21.88,88.99 -48.88,88.99 -27,0 -48.89,-39.84 -48.89,-88.99 0,-49.15 21.89,-88.99 48.89,-88.99z"
});

function SvgMediumIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium-icon.1e817391.svg";
export { ForwardRef as ReactComponent };